/****************************************************
 * Module Name:  stoneLabStatusProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StoneLabstatusProxy {
  static GetAllStoneLabstatus = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStoneLabstatusMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleStoneLabstatus = (stoneLabstatusId, callback) => {
    let params = {
      id: stoneLabstatusId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckStoneLabstatusAvailable = (stoneLabstatus, callback) => {
    let params = {
      stonelabstatus: stoneLabstatus,
    };

    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddStoneLabstatus = (stonestatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(stonestatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateStoneLabstatus = (stonestatus, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stonelabstatus",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(stonestatus),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
